import { UserCheck } from "lucide-react";

export function EmptyReferralsState() {
  return (
    <div className="text-center py-12">
      <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
        {/* //TODO: Add a different icon here */}
        <UserCheck className="h-10 w-10 text-blue-500" />
      </div>
      <h4 className="text-lg font-semibold text-gray-900 mb-2">
        Ready to make your first referral?
      </h4>
      <p className="text-gray-500 max-w-sm mx-auto">
        Start earning rewards by referring talented candidates to open positions. Each successful hire can earn you significant bonuses!
      </p>
    </div>
  );
}
